import React from "react";

import { LogUnionRowItem } from "@common/components/MasterTable/models/MasterTableModel";
import { getActivityHistoryCellStyle, isCellError } from "@common/components/ShakeTable/ui/activityHistory/DomainCell";
import { BaseCell } from "@common/components/ShakeTable/ui/BaseCell";
import { LogType, NetworkRequest } from "@common/models/eventTracking";
import { CellContext } from "@tanstack/react-table";

interface SizeCellProps {
  // eslint-disable-next-line
  info: CellContext<LogUnionRowItem, any>;
}

const SizeCell = ({ info }: SizeCellProps) => {
  const item = info.row.original;
  if (!item) return null;

  const isError = isCellError(info);

  return (
    <BaseCell
      style={getActivityHistoryCellStyle(isError)}
      withBorder={info.table.getSelectedRowModel()?.rows[0]?.index - 1 === info.row.index || info.row.getIsSelected()}
    >
      {info.row.original.instance_type === LogType.NETWORK_REQUEST ? estimateNetworkRequestSize(info.row.original) : ""}
    </BaseCell>
  );
};

const estimateNetworkRequestSize = (networkRequest: NetworkRequest): string => {
  let size = 0;
  const encoder = new TextEncoder();

  size += encoder.encode(`${networkRequest.method} ${networkRequest.url} HTTP/1.1\r\n`).length;

  for (const [key, value] of Object.entries(networkRequest.response_headers)) {
    size += encoder.encode(`${key}: ${value}\r\n`).length;
  }

  size += encoder.encode(`\r\n`).length;

  if (networkRequest.response_body !== null) {
    size += encoder.encode(networkRequest.response_body).length;
  }

  return formatBytes(size);
};

const formatBytes = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

export { SizeCell };
